import type { PropsWithChildren } from "react";

import { Tooltip } from "@similarweb/ui-components";

import Content from "./Content";
import NoTouchContent from "./NoTouchContent";
import TrialContent from "./TrialContent";

type Props = PropsWithChildren<{
    isAdmin: boolean;
    isNoTouch: boolean;
    isTrial: boolean;
    quota: number;
}>;

type TooltipContentProps = {
    isAdmin: boolean;
    isNoTouch: boolean;
    isTrial: boolean;
    hasPartialCredits: boolean;
    quota: number;
};

const TooltipContent = ({ isAdmin, isNoTouch, isTrial, hasPartialCredits, quota }: TooltipContentProps) => {
    if (isTrial) {
        return <TrialContent hasPartialCredits={hasPartialCredits} />;
    }

    if (isNoTouch) {
        return <NoTouchContent hasPartialCredits={hasPartialCredits} />;
    }

    return (
        <Content
            isAdmin={isAdmin}
            quota={quota}
            hasPartialCredits={hasPartialCredits}
        />
    );
};

export const NotEnoughQuotaTooltip = ({ isAdmin, isNoTouch, isTrial, quota, children }: Props) => {
    const hasPartialCredits = quota > 0;

    return (
        <Tooltip
            placement="top"
            content={
                <TooltipContent
                    isAdmin={isAdmin}
                    isNoTouch={isNoTouch}
                    isTrial={isTrial}
                    hasPartialCredits={hasPartialCredits}
                    quota={quota}
                />
            }
        >
            {children}
        </Tooltip>
    );
};
